import { MODULE_PAGE_BASE_PATH, MODULE_PAGES, PUBLIC_ARTBOARDS } from '@/constants/modulePages';
import type { ModulePageDefinition, ModulePageGroup, ModulePageSlug, PublicArtboardLayout } from '@/types/modulePages';

export function getModulePagePath(slug: ModulePageSlug) {
  return `${MODULE_PAGE_BASE_PATH}/${slug}`;
}

export function getModulePage(slug: ModulePageSlug): ModulePageDefinition {
  // MODULE_PAGES her slug'ı içerir (tip garantisi ModulePageSlug birleşimiyle).
  return MODULE_PAGES.find((module) => module.slug === slug) as ModulePageDefinition;
}

export function getModulePagesByGroup(group: ModulePageGroup) {
  return MODULE_PAGES.filter((module) => module.group === group);
}

// Aktif artboard ekran genişliğine ölçeklenir; masaüstü (1280px) yalnızca küçülür, mobil/tablet üst sınırlı büyür.
export function getPublicArtboardZoom(layout: PublicArtboardLayout) {
  const { width, maxZoom } = PUBLIC_ARTBOARDS[layout];
  return Math.min(document.documentElement.clientWidth / width, maxZoom);
}
